
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 24","height":"12","width":"7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.687.691a2.371 2.371 0 000 3.34L8.561 12 .687 19.97a2.367 2.367 0 000 3.336 2.348 2.348 0 003.334 0l9.316-9.431c.515-.515.712-1.202.653-1.875.059-.668-.138-1.359-.653-1.872L4.021.691a2.356 2.356 0 00-3.334 0"}})])
          )
        }
      }
    